var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 88,
    viewBox: "0 0 110 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_1528_19365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4039 123.408C83.4692 131.614 112.871 115.522 121.074 87.466C129.278 59.4095 113.177 30.0129 85.1115 21.8068C57.0463 13.6007 27.6447 29.6926 19.4411 57.7491C11.2376 85.8056 27.3387 115.202 55.4039 123.408Z",
    fill: "#9097C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.895 117.315C80.9603 125.521 110.362 109.429 118.565 81.3726C126.769 53.3161 110.668 23.9195 82.6026 15.7134C54.5374 7.50736 25.1357 23.5993 16.9322 51.6558C8.7287 79.7123 24.8298 109.109 52.895 117.315Z",
    fill: "#C7CFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1029 106.344C78.1071 112.778 101.159 100.161 107.591 78.1638C114.023 56.1664 101.399 33.1184 79.3947 26.6845C57.3905 20.2506 34.3386 32.8673 27.9067 54.8647C21.4748 76.862 34.0987 99.9101 56.1029 106.344Z",
    fill: "#9097C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.438 36.0607C79.8554 36.4751 81.3402 35.6625 81.7545 34.2456C82.1688 32.8287 81.3556 31.3441 79.9383 30.9297C78.521 30.5153 77.0362 31.328 76.6219 32.7448C76.2076 34.1617 77.0207 35.6463 78.438 36.0607Z",
    fill: "#C7CFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.952 34.8943C62.3693 35.3087 63.8541 34.496 64.2684 33.0791C64.6827 31.6623 63.8696 30.1777 62.4522 29.7633C61.0349 29.3489 59.5501 30.1615 59.1358 31.5784C58.7215 32.9953 59.5346 34.4799 60.952 34.8943Z",
    fill: "#C7CFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2251 42.6247C46.6424 43.0391 48.1272 42.2264 48.5415 40.8095C48.9558 39.3927 48.1427 37.9081 46.7254 37.4937C45.308 37.0793 43.8232 37.8919 43.4089 39.3088C42.9946 40.7257 43.8078 42.2103 45.2251 42.6247Z",
    fill: "#C7CFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4742 57.1823C36.8915 57.5967 38.3763 56.784 38.7906 55.3671C39.2049 53.9503 38.3918 52.4657 36.9744 52.0513C35.5571 51.6369 34.0723 52.4495 33.658 53.8664C33.2437 55.2833 34.0568 56.7679 35.4742 57.1823Z",
    fill: "#C7CFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3104 74.6635C35.7277 75.078 37.2125 74.2653 37.6268 72.8484C38.0411 71.4315 37.228 69.947 35.8106 69.5325C34.3933 69.1181 32.9085 69.9308 32.4942 71.3477C32.0799 72.7646 32.893 74.2491 34.3104 74.6635Z",
    fill: "#C7CFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0454 90.3876C43.4627 90.802 44.9475 89.9893 45.3618 88.5724C45.7761 87.1556 44.963 85.671 43.5457 85.2566C42.1283 84.8422 40.6435 85.6548 40.2292 87.0717C39.8149 88.4886 40.6281 89.9732 42.0454 90.3876Z",
    fill: "#C7CFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8214 93.5745C91.2387 93.9889 92.7235 93.1762 93.1378 91.7593C93.5521 90.3424 92.739 88.8579 91.3217 88.4435C89.9043 88.029 88.4195 88.8417 88.0052 90.2586C87.5909 91.6755 88.4041 93.16 89.8214 93.5745Z",
    fill: "#C7CFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5723 79.0169C100.99 79.4313 102.474 78.6186 102.889 77.2017C103.303 75.7848 102.49 74.3003 101.073 73.8859C99.6553 73.4714 98.1704 74.2841 97.7562 75.701C97.3419 77.1179 98.155 78.6024 99.5723 79.0169Z",
    fill: "#C7CFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.736 61.5356C102.153 61.95 103.638 61.1374 104.053 59.7205C104.467 58.3036 103.654 56.819 102.236 56.4046C100.819 55.9902 99.3343 56.8028 98.92 58.2197C98.5057 59.6366 99.3188 61.1212 100.736 61.5356Z",
    fill: "#C7CFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0011 45.8115C94.4184 46.226 95.9032 45.4133 96.3175 43.9964C96.7318 42.5795 95.9187 41.095 94.5014 40.6805C93.084 40.2661 91.5992 41.0788 91.1849 42.4957C90.7706 43.9126 91.5838 45.3971 93.0011 45.8115Z",
    fill: "#C7CFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8611 72.7842C51.5127 72.6826 51.2086 72.467 50.9975 72.1719C50.7864 71.8769 50.6805 71.5195 50.6969 71.1571C50.7132 70.7948 50.8509 70.4484 51.0877 70.1737C51.3245 69.8989 51.6468 69.7117 52.0029 69.642L66.955 66.7159L73.9286 42.8658C74.049 42.4538 74.3283 42.1065 74.7049 41.9004C75.0815 41.6943 75.5246 41.6461 75.9368 41.7667C76.3489 41.8872 76.6963 42.1664 76.9025 42.543C77.1088 42.9195 77.157 43.3625 77.0365 43.7745L69.5163 69.494L52.6212 72.8175C52.3688 72.8669 52.1082 72.8555 51.8611 72.7842Z",
    fill: "#C7CFEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1528_19365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 111,
    fill: "white",
    transform: "translate(31.786 0.855019) rotate(16.2985)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d22187a7a4a3e2921f6417751f077681.svg";
export { ForwardRef as ReactComponent };